<ion-content class="ion-padding">
  <h3 class="text">Schedule Trip</h3>
  <ion-item>
    <ion-label>D MMM YYYY H:mm</ion-label>
    <ion-datetime displayFormat="D MMM YYYY H:mm" 
    [min]="dateNow.getFullYear()" [value]="dateNow"></ion-datetime>
  </ion-item>
</ion-content>
